import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { EmptyBlock } from '../elements/EmptyBlock';

const Psst = styled.div`
    position: absolute;
    top: 2rem;
    left: 2rem;
    font-family: 'Caveat';
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1.15em;
    color: ${Colors.textMenu};
    transform: rotate(-5deg);
    user-select: none;

    svg {
        position: absolute;
        left: 100%;
        top: 0.25rem;
        width: 1.5rem;
        margin-left: 1rem;
    }
`;

export const BoardsEmpty = () =>
    <EmptyBlock
        title={'There are no boards in here yet.'}
        subtitle="Check out the guides and tips below to get started!"
    >
        <Psst>
            &nbsp;&nbsp;&nbsp;Pssst... make your <br />first board up there
            <svg viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.88672 1.13867C7.45625 2.92524 5.82245 7.46083 2.73104 11.3106" stroke={Colors.textMenu} strokeLinecap="round" />
                <path d="M8.94489 2.82052L7.8859 1.13898L5.82264 1.92653" stroke={Colors.textMenu} strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </Psst>
    </EmptyBlock>;
